class Utils{
    static renderBigNumber = (num, options = { maximumFractionDigits: 2 }) => {
        return num ? num.toLocaleString(undefined, options) : 0
    }
    
    static renderSOL = (num, symbol = 'SOL') => {
        return num != null && num != undefined && num != NaN ? `${Utils.renderBigNumber(num, { maximumFractionDigits: 3 })} ${symbol}` : '-'
    }
    
    static renderPercentage = (num) => {
        return num != null && num != undefined && num != NaN ? `${Utils.renderBigNumber(num, { maximumFractionDigits: 2 })}%` : '-'
    }

    static Timer = (ms) => {
        let id;
    
        const start = () => new Promise(resolve => {
            if (id === -1) {
                throw new Error('Timer already aborted');
            }
    
            id = setTimeout(resolve, ms);
        });
    
        const abort = () => {
            if (id !== -1 || id === undefined) {
                clearTimeout(id);
                id = -1;
            }
        }
    
        return {
            start, abort
        }
    };
    
    static formatPoints = (points) => {
      let p = parseFloat(points);
      return p >= 100 ? p.toFixed(2) : p.toFixed(3);
    };

    // Clamp number between two values with the following line:
    static clamp = (num, min, max) => Math.min(Math.max(num, min), max);
}

export default Utils;